import React, { useEffect, useState } from "react";

type Props = {
  items: { key: string; label: string }[];
  activeKey: string;
  onChange: (key: string) => void;
};

const TabsButton = ({ items, onChange, activeKey }: Props) => {
  return (
    <>
      <div className="tabs-group">
        {items.map((e) => (
          <div
            className={`tab-button ${activeKey === e.key ? "active" : ""}`}
            key={e.key}
            title={e.label}
            onClick={() => {
              onChange(e.key);
            }}
          >
            {e.label}
          </div>
        ))}
      </div>
    </>
  );
};

export default TabsButton;
